var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageDependentRegister"},[_c('v-toolbar-title',[_vm._v("Cadastrar dependente")]),_c('form-dependent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }